// import React, { useState } from "react";
// import {
//   Box,
//   Card,
//   Stack,
//   Typography,
//   Button,
//   Collapse,
//   //   Chip,
// } from "@mui/material";
// import {
//   HomeRounded,
//   BadgeOutlined,
//   SupportAgentOutlined,
//   SchoolOutlined,
//   PeopleOutlined,
//   InfoOutlined,
//   NotificationsOutlined,
//   StorefrontRounded,
//   LogoutOutlined,
//   ExpandLessRounded,
//   ExpandMoreRounded,
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   ADMIN_NAV,
//   MESSAGES,
//   version,
//   primaryDark,
//   accentColor,
//   adminBgGradient,
//   myApi,
// } from "../../../constants/consts";

// const slideInLeft = keyframes`
//   from { opacity: 0; transform: translateX(-24px); }
//   to   { opacity: 1; transform: translateX(0); }
// `;
// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(12px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// const ICONS = {
//   home: HomeRounded,
//   badge: BadgeOutlined,
//   support: SupportAgentOutlined,
//   school: SchoolOutlined,
//   people: PeopleOutlined,
//   info: InfoOutlined,
//   notifications: NotificationsOutlined,
// };

// export default function AdminLayout({ user, onLogout, children }) {
//   const navigate = useNavigate();
//   const { pathname } = useLocation();

//   const activeGroup = ADMIN_NAV.find((g) =>
//     g.children.some((c) =>
//       pathname.startsWith(c.path.split("/").slice(0, 3).join("/")),
//     ),
//   )?.key;

//   const [open, setOpen] = useState({ [activeGroup || "home"]: true });

//   const toggleGroup = (key) =>
//     setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

//   return (
//     <Box
//       sx={{
//         height: "100dvh",
//         display: "flex",
//         overflow: "hidden",
//         background: adminBgGradient,
//       }}
//     >
//       {/* SIDEBAR */}
//       <Box
//         sx={{
//           width: { xs: 78, md: 260 },
//           flexShrink: 0,
//           p: { xs: 1, md: 2 },
//           display: "flex",
//           flexDirection: "column",
//           gap: 2,
//           height: "100%",
//           minHeight: 0,
//           overflow: "hidden",
//           animation: `${slideInLeft} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both`,
//         }}
//       >
//         <Card
//           sx={{
//             flex: 1,
//             minHeight: 0,
//             borderRadius: 3,
//             p: 1.5,
//             display: "flex",
//             flexDirection: "column",
//             gap: 1.5,
//             backgroundColor: "rgba(255,255,255,0.98)",
//             boxShadow: "0 12px 32px rgba(0,0,0,0.30)",
//             overflow: "hidden",
//           }}
//         >
//           {/* Logo */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               py: 1,
//               animation: `${fadeInUp} 0.4s ease-out 0.1s backwards`,
//             }}
//           >
//             <Box
//               component="img"
//               src="/images/logo.png"
//               alt="Nortek"
//               sx={{
//                 height: { xs: 22, md: 30 },
//                 width: "auto",
//                 objectFit: "contain",
//                 filter: "drop-shadow(0 3px 8px rgba(0,0,0,0.15))",
//               }}
//             />
//           </Box>

//           {/* Nav */}
//           <Stack
//             sx={{ flex: 1, minHeight: 0, overflowY: "auto", gap: 0.5, mt: 1 }}
//           >
//             {ADMIN_NAV.map((group, i) => {
//               const Icon = ICONS[group.icon];
//               const isOpen = !!open[group.key];
//               const isActiveGroup = group.children.some(
//                 (c) => pathname === c.path,
//               );

//               return (
//                 <Box
//                   key={group.key}
//                   sx={{
//                     animation: `${fadeInUp} 0.4s ease-out ${0.15 + i * 0.04}s backwards`,
//                   }}
//                 >
//                   <Box
//                     onClick={() => toggleGroup(group.key)}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1.25,
//                       px: { xs: 1, md: 1.5 },
//                       py: 1,
//                       borderRadius: 2,
//                       cursor: "pointer",
//                       justifyContent: { xs: "center", md: "flex-start" },
//                       color: isActiveGroup ? "#fff" : "#334155",
//                       background: isActiveGroup
//                         ? `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`
//                         : "transparent",
//                       boxShadow: isActiveGroup
//                         ? "0 6px 16px rgba(4,87,129,0.30)"
//                         : "none",
//                       fontWeight: 700,
//                       fontSize: 13,
//                       transition:
//                         "transform 0.22s cubic-bezier(0.22,1,0.36,1), background 0.22s ease, color 0.22s ease",
//                       "&:hover": {
//                         transform: "translateX(3px)",
//                         background: isActiveGroup
//                           ? undefined
//                           : "rgba(4,87,129,0.07)",
//                       },
//                       "&:active": { transform: "translateX(1px) scale(0.98)" },
//                     }}
//                   >
//                     <Icon sx={{ fontSize: 19 }} />
//                     <Box
//                       component="span"
//                       sx={{
//                         display: { xs: "none", md: "inline" },
//                         flex: 1,
//                       }}
//                     >
//                       {group.label}
//                     </Box>
//                     {group.children.length > 1 && (
//                       <Box
//                         component="span"
//                         sx={{
//                           display: { xs: "none", md: "inline-flex" },
//                           transition: "transform 0.25s ease",
//                           transform: isOpen ? "rotate(180deg)" : "none",
//                         }}
//                       >
//                         {isOpen ? (
//                           <ExpandLessRounded sx={{ fontSize: 16 }} />
//                         ) : (
//                           <ExpandMoreRounded sx={{ fontSize: 16 }} />
//                         )}
//                       </Box>
//                     )}
//                   </Box>

//                   <Collapse in={isOpen && true} timeout={250}>
//                     <Stack sx={{ ml: { xs: 0, md: 2 }, mt: 0.5, gap: 0.25 }}>
//                       {group.children.map((item) => {
//                         const isSelected = pathname === item.path;
//                         return (
//                           <Box
//                             key={item.path}
//                             onClick={() => navigate(item.path)}
//                             sx={{
//                               display: { xs: "none", md: "flex" },
//                               alignItems: "center",
//                               px: 1.5,
//                               py: 0.75,
//                               borderRadius: 1.5,
//                               cursor: "pointer",
//                               color: isSelected ? primaryDark : "#475569",
//                               background: isSelected
//                                 ? "rgba(4,87,129,0.10)"
//                                 : "transparent",
//                               fontWeight: isSelected ? 800 : 600,
//                               fontSize: 12,
//                               transition:
//                                 "background-color 0.2s ease, color 0.2s ease, transform 0.15s ease",
//                               "&:hover": {
//                                 background: "rgba(4,87,129,0.05)",
//                                 transform: "translateX(2px)",
//                               },
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 width: 6,
//                                 height: 6,
//                                 borderRadius: "50%",
//                                 backgroundColor: isSelected
//                                   ? primaryDark
//                                   : "#CBD5E1",
//                                 mr: 1.25,
//                                 transition: "background-color 0.2s ease",
//                               }}
//                             />
//                             {item.label}
//                           </Box>
//                         );
//                       })}
//                     </Stack>
//                   </Collapse>
//                 </Box>
//               );
//             })}
//           </Stack>

//           {/* Store + logout + version */}
//           <Stack spacing={1} sx={{ mt: "auto" }}>
//             <Button
//               fullWidth
//               onClick={() => window.open(myApi, "_blank")}
//               startIcon={<StorefrontRounded />}
//               sx={{
//                 justifyContent: { xs: "center", md: "flex-start" },
//                 textTransform: "none",
//                 fontWeight: 700,
//                 color: primaryDark,
//                 borderRadius: 2,
//                 px: 1.5,
//                 animation: `${fadeInUp} 0.4s ease-out 0.55s backwards`,
//                 "& .MuiButton-startIcon": { mr: { xs: 0, md: 1 } },
//                 "&:hover": { backgroundColor: "rgba(4,87,129,0.08)" },
//               }}
//             >
//               <Box
//                 component="span"
//                 sx={{ display: { xs: "none", md: "inline" } }}
//               >
//                 Nortek Store
//               </Box>
//             </Button>

//             <Button
//               fullWidth
//               onClick={onLogout}
//               startIcon={<LogoutOutlined />}
//               sx={{
//                 justifyContent: { xs: "center", md: "flex-start" },
//                 textTransform: "none",
//                 fontWeight: 700,
//                 color: "#B91C1C",
//                 borderRadius: 2,
//                 px: 1.5,
//                 animation: `${fadeInUp} 0.4s ease-out 0.62s backwards`,
//                 "& .MuiButton-startIcon": { mr: { xs: 0, md: 1 } },
//                 "&:hover": { backgroundColor: "rgba(185,28,28,0.08)" },
//               }}
//             >
//               <Box
//                 component="span"
//                 sx={{ display: { xs: "none", md: "inline" } }}
//               >
//                 {MESSAGES.ADMIN_LOGOUT}
//               </Box>
//             </Button>

//             <Typography
//               variant="caption"
//               sx={{
//                 textAlign: "center",
//                 color: "#94A3B8",
//                 fontWeight: 700,
//                 animation: `${fadeInUp} 0.4s ease-out 0.68s backwards`,
//               }}
//             >
//               {version}
//             </Typography>
//           </Stack>
//         </Card>
//       </Box>

//       {/* CONTENT */}
//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           flex: 1,
//           minWidth: 0,
//           height: "100%",
//           display: "flex",
//           flexDirection: "column",
//           p: { xs: 1.5, md: 2 },
//           boxSizing: "border-box",
//           overflow: "hidden",
//           animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
//         }}
//       >
//         {children}
//       </Box>
//     </Box>
//   );
// }
import React, { useState } from "react";
import {
  Box,
  Card,
  Stack,
  Typography,
  Button,
  Collapse,
  useMediaQuery,
  //   Chip,
} from "@mui/material";
import {
  HomeRounded,
  BadgeOutlined,
  SupportAgentOutlined,
  SchoolOutlined,
  PeopleOutlined,
  InfoOutlined,
  NotificationsOutlined,
  StorefrontRounded,
  LogoutOutlined,
  ExpandLessRounded,
  ExpandMoreRounded,
} from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ADMIN_NAV,
  MESSAGES,
  version,
  primaryDark,
  accentColor,
  adminBgGradient,
  myApi,
} from "../../../constants/consts";

const slideInLeft = keyframes`
  from { opacity: 0; transform: translateX(-24px); }
  to   { opacity: 1; transform: translateX(0); }
`;
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const ICONS = {
  home: HomeRounded,
  badge: BadgeOutlined,
  support: SupportAgentOutlined,
  school: SchoolOutlined,
  people: PeopleOutlined,
  info: InfoOutlined,
  notifications: NotificationsOutlined,
};

export default function AdminLayout({ user, onLogout, children }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // md altında menü yalnızca ikon gösterir; alt başlıklar gizli olduğundan
  // ikona tıklayınca grubun ilk sayfasına gidilir.
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const activeGroup = ADMIN_NAV.find((g) =>
    g.children.some((c) =>
      pathname.startsWith(c.path.split("/").slice(0, 3).join("/")),
    ),
  )?.key;

  const [open, setOpen] = useState({ [activeGroup || "home"]: true });

  const toggleGroup = (key) =>
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <Box
      sx={{
        height: "100dvh",
        display: "flex",
        overflow: "hidden",
        background: adminBgGradient,
      }}
    >
      {/* SIDEBAR */}
      <Box
        sx={{
          width: { xs: 78, md: 288, lg: 308 },
          flexShrink: 0,
          p: { xs: 1, md: 2 },
          display: "flex",
          flexDirection: "column",
          gap: 2,
          height: "100%",
          minHeight: 0,
          overflow: "hidden",
          animation: `${slideInLeft} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both`,
        }}
      >
        <Card
          sx={{
            flex: 1,
            minHeight: 0,
            borderRadius: 3,
            p: 1.5,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            backgroundColor: "rgba(255,255,255,0.98)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.30)",
            overflow: "hidden",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 1,
              animation: `${fadeInUp} 0.4s ease-out 0.1s backwards`,
            }}
          >
            <Box
              component="img"
              src="/images/logo.png"
              alt="Nortek"
              sx={{
                height: { xs: 22, md: 30 },
                width: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 3px 8px rgba(0,0,0,0.15))",
              }}
            />
          </Box>

          {/* Nav */}
          <Stack
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden", // yatay kaydırma çubuğu çıkmasın
              gap: 0.5,
              mt: 1,
            }}
          >
            {ADMIN_NAV.map((group, i) => {
              const Icon = ICONS[group.icon];
              const isOpen = !!open[group.key];
              const isActiveGroup = group.children.some(
                (c) => pathname === c.path,
              );

              return (
                <Box
                  key={group.key}
                  sx={{
                    animation: `${fadeInUp} 0.4s ease-out ${0.15 + i * 0.04}s backwards`,
                  }}
                >
                  <Box
                    onClick={() =>
                      isMdUp
                        ? toggleGroup(group.key)
                        : navigate(group.children[0].path)
                    }
                    title={group.label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      minWidth: 0,
                      gap: 1.25,
                      px: { xs: 1, md: 1.5 },
                      py: 1,
                      borderRadius: 2,
                      cursor: "pointer",
                      justifyContent: { xs: "center", md: "flex-start" },
                      color: isActiveGroup ? "#fff" : "#334155",
                      background: isActiveGroup
                        ? `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`
                        : "transparent",
                      boxShadow: isActiveGroup
                        ? "0 6px 16px rgba(4,87,129,0.30)"
                        : "none",
                      fontWeight: 700,
                      fontSize: 13,
                      transition:
                        "transform 0.22s cubic-bezier(0.22,1,0.36,1), background 0.22s ease, color 0.22s ease",
                      "&:hover": {
                        background: isActiveGroup
                          ? undefined
                          : "rgba(4,87,129,0.07)",
                      },
                      "&:active": { transform: "scale(0.98)" },
                    }}
                  >
                    <Icon sx={{ fontSize: 19 }} />
                    <Box
                      component="span"
                      sx={{
                        display: { xs: "none", md: "block" },
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {group.label}
                    </Box>
                    {group.children.length > 1 && (
                      <Box
                        component="span"
                        sx={{
                          display: { xs: "none", md: "inline-flex" },
                          transition: "transform 0.25s ease",
                          transform: isOpen ? "rotate(180deg)" : "none",
                        }}
                      >
                        {isOpen ? (
                          <ExpandLessRounded sx={{ fontSize: 16 }} />
                        ) : (
                          <ExpandMoreRounded sx={{ fontSize: 16 }} />
                        )}
                      </Box>
                    )}
                  </Box>

                  <Collapse in={isOpen && true} timeout={250}>
                    <Stack sx={{ ml: { xs: 0, md: 2 }, mt: 0.5, gap: 0.25 }}>
                      {group.children.map((item) => {
                        const isSelected = pathname === item.path;
                        return (
                          <Box
                            key={item.path}
                            onClick={() => navigate(item.path)}
                            title={item.label}
                            sx={{
                              display: { xs: "none", md: "flex" },
                              alignItems: "center",
                              minWidth: 0,
                              px: 1.5,
                              py: 0.75,
                              borderRadius: 1.5,
                              cursor: "pointer",
                              color: isSelected ? primaryDark : "#475569",
                              background: isSelected
                                ? "rgba(4,87,129,0.10)"
                                : "transparent",
                              fontWeight: isSelected ? 800 : 600,
                              fontSize: 12,
                              transition:
                                "background-color 0.2s ease, color 0.2s ease, transform 0.15s ease",
                              "&:hover": {
                                background: "rgba(4,87,129,0.05)",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                backgroundColor: isSelected
                                  ? primaryDark
                                  : "#CBD5E1",
                                mr: 1.25,
                                flexShrink: 0,
                                transition: "background-color 0.2s ease",
                              }}
                            />
                            <Box
                              component="span"
                              sx={{
                                minWidth: 0,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.label}
                            </Box>
                          </Box>
                        );
                      })}
                    </Stack>
                  </Collapse>
                </Box>
              );
            })}
          </Stack>

          {/* Store + logout + version */}
          <Stack spacing={1} sx={{ mt: "auto" }}>
            <Button
              fullWidth
              onClick={() => window.open(myApi, "_blank")}
              startIcon={<StorefrontRounded />}
              sx={{
                justifyContent: { xs: "center", md: "flex-start" },
                textTransform: "none",
                fontWeight: 700,
                color: primaryDark,
                borderRadius: 2,
                px: 1.5,
                animation: `${fadeInUp} 0.4s ease-out 0.55s backwards`,
                "& .MuiButton-startIcon": { mr: { xs: 0, md: 1 } },
                "&:hover": { backgroundColor: "rgba(4,87,129,0.08)" },
              }}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", md: "inline" } }}
              >
                Nortek Store
              </Box>
            </Button>

            <Button
              fullWidth
              onClick={onLogout}
              startIcon={<LogoutOutlined />}
              sx={{
                justifyContent: { xs: "center", md: "flex-start" },
                textTransform: "none",
                fontWeight: 700,
                color: "#B91C1C",
                borderRadius: 2,
                px: 1.5,
                animation: `${fadeInUp} 0.4s ease-out 0.62s backwards`,
                "& .MuiButton-startIcon": { mr: { xs: 0, md: 1 } },
                "&:hover": { backgroundColor: "rgba(185,28,28,0.08)" },
              }}
            >
              <Box
                component="span"
                sx={{ display: { xs: "none", md: "inline" } }}
              >
                {MESSAGES.ADMIN_LOGOUT}
              </Box>
            </Button>

            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                color: "#94A3B8",
                fontWeight: 700,
                animation: `${fadeInUp} 0.4s ease-out 0.68s backwards`,
              }}
            >
              {version}
            </Typography>
          </Stack>
        </Card>
      </Box>

      {/* CONTENT */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          minWidth: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          p: { xs: 1.5, md: 2 },
          boxSizing: "border-box",
          overflow: "hidden",
          animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
